export default __webpack_public_path__ + "static/logo_black_LST_wo_tag-8ec3e8896e5258a5c8d5ba94db65090c.png";